/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 02:35 pm
 * Last Modified: Thursday, 24-07-11 10:30 pm, by Harper Yan
 */

import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';

import { SnackbarProps } from '@mui/material';

import { HideFn, ShowFn } from './@types';

export type SnackbarState = {
  snackbarProps?: SnackbarProps;
  show: ShowFn;
  hide: HideFn;
};

// @ts-ignore
const store = createStore<SnackbarState, [['zustand/immer', never]]>(
  immer((set, get) => ({
    snackbar: {},
    show: (props) => {
      set(() => ({
        snackbarProps: {
          ...(props || {}),
          open: true,
        },
      }));

      return get().hide;
    },
    hide: () => {
      if (!get().snackbarProps) {
        return;
      }

      set((state) => {
        state.snackbarProps!.open = false;
      });
    },
  }))
);

export default store;

const { getState, setState, subscribe, getInitialState } = store;

export const showSnackbar = getState().show;
export const hideSnackbar = getState().hide;
